import styled from 'styled-components';
import { ViewOptionsPerspectives as ViewOptionsPerspectivesBase } from './ViewOptionsPerspectives';
import { ConnectedViewOptionsViewSettings as ViewOptionsViewSettings } from './ViewOptionsViewSettings';

const Container = styled.div`
  display: flex;

  flex-direction: column;
  align-items: flex-start;

  align-self: stretch;
`;

const PerspectivesAndViewSettings = () => {
  return (
    <Container>
      <ViewOptionsPerspectivesBase />
      <ViewOptionsViewSettings />
    </Container>
  );
};
export { PerspectivesAndViewSettings };
